import { Link } from "react-router-dom";
import { LockKey, ArrowLeft } from "@phosphor-icons/react";
import { useAuth } from "../contexts/AuthContext";
import { firstAccessibleAdminPath } from "../lib/adminMenuCatalog";

export default function Forbidden() {
  const { user } = useAuth();
  // Phase 85.A.273 — nút "Về" trỏ tới trang user THỰC SỰ có quyền vào, không
  // cứng /admin/dashboard (organizer/admin không có menu dashboard → kẹt 403).
  const homePath = firstAccessibleAdminPath(user) || "/";
  const homeLabel = homePath === "/" ? "Về trang chủ" : "Về Tổng quan";
  return (
    <div className="min-h-screen bg-[#0A0F14] text-white flex items-center justify-center px-5">
      <div className="max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-red-500/10 border border-red-500/30 flex items-center justify-center mx-auto mb-5">
          <LockKey size={28} weight="bold" className="text-red-400" />
        </div>
        <div className="text-[11px] tracking-[0.32em] uppercase font-mono text-red-400 mb-2">// 403 Forbidden</div>
        <h1 className="font-heading text-3xl font-black tracking-tight mb-2">Không có quyền truy cập</h1>
        <p className="text-white/50 text-sm mb-6">
          Tài khoản của bạn không có quyền vào trang này. Liên hệ Super Admin nếu đây là nhầm lẫn.
        </p>
        <Link
          to={homePath}
          className="inline-flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-[#4F8DFF] to-[#2563EB] hover:from-[#60A5FA] hover:to-[#3B82F6] text-white font-mono uppercase text-xs tracking-[0.22em] font-bold rounded-lg transition"
          data-testid="forbidden-home-link"
        >
          <ArrowLeft size={14} weight="bold" />
          {homeLabel}
        </Link>
      </div>
    </div>
  );
}
